import React from 'react'
import styles from './Input.module.css'

export const Input = ({ name, type, label, placeholder, value, onChange, onBlur }) => {
  return (
    <div>
      <label htmlFor={name}>{label}</label>
      <input id={name} className={styles.input} name={name} type={type} placeholder={placeholder} value={value} onChange={onChange} onBlur={onBlur} />
    </div>
  )
}
